export default __webpack_public_path__ + "static/media/2.1b34386e.png";